import { QCWorkflowObjective } from "app/js/src/domain/qc-workflow";
import {
  ChangeToApprove,
  ETenantSettingActionType,
} from "./tenant-setting-change";

export class DeleteQCWorkflowObjectiveChangeToApprove extends ChangeToApprove {
  constructor(
    public objective: QCWorkflowObjective,
    public message: string,
  ) {
    super(
      objective.id,
      ETenantSettingActionType.DeleteQCWorkflowObjective,
      message,
    );
  }
}
